import BaseMovement from './Base'
import PlayerMoveToWithSpeed from './PlayerMoveToWithSpeed'
import {calculateDistance} from '../helper'

export default class OvertakeOtherEntity extends BaseMovement {
    constructor(entity, targetEntity, speed, minDistance) {
        super(entity, null);
        this.Speed = speed;
        this.TargetEntity = targetEntity;
        this.MoveSegment = 15;
        this.MinDistance = minDistance;
    }

    Play(gameSpeed) {       
        return new Promise(function(resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;
            this.move(gameSpeed);
        }.bind(this));
    }

    move(gameSpeed) {
        if(this.IsCancelled){
            this.reject('cancelled');
            return;
        }
        
        let distance = calculateDistance(this.Entity.CurrentPosition, this.getTargetPosition());
        if(distance < this.MinDistance)
            this.resolve('goal reached');
        
        this.moveCloser(gameSpeed).then(() => this.move(gameSpeed)).catch((res)=> {
            if(res == 'cancelled')
                this.reject('cancelled');
            else
                throw "unknown error!";
        });
    }
    
    moveCloser(gameSpeed) {
        
        let distance = calculateDistance(this.Entity.CurrentPosition, this.getTargetPosition());
        let segmentPercent = this.MoveSegment / distance;

        var startPosition = {Top: this.Entity.CurrentPosition.Top, Left: this.Entity.CurrentPosition.Left};

        var topDiff = this.getTargetPosition().Top - startPosition.Top;
        var leftDiff = this.getTargetPosition().Left - startPosition.Left;

        let new_position = { Top: startPosition.Top + topDiff * segmentPercent, Left: startPosition.Left + leftDiff * segmentPercent };    
            
        this.CurrentStep = new PlayerMoveToWithSpeed(this.Entity, this.Speed, new_position);
        return this.CurrentStep.Play(gameSpeed);
    }

    getTargetPosition() {
        let entitySide = this.Entity.props.home != null ? this.Entity.props.home : true;
        return this.TargetEntity.convertToHomeAwayPosition != null ? this.TargetEntity.convertToHomeAwayPosition(entitySide) : this.TargetEntity.CurrentPosition;
    }

    Cancell() {        
        this.IsCancelled = true;
        
        if(this.CurrentStep != null){
            this.CurrentStep.Cancell();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/OvertakeOtherEntity.js
 **/